var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.noDrawer
    ? _c(
        "Cropper",
        _vm._b(
          {
            ref: "cropper",
            attrs: { src: _vm.imgUrl },
            on: {
              loading: function (v) {
                return _vm.$emit("loading", v)
              },
              "save-disable": function (v) {
                return _vm.$emit("disable", v)
              },
              complete: _vm.onComplete,
            },
          },
          "Cropper",
          _vm.$attrs,
          false
        )
      )
    : _c(
        "yxt-drawer",
        {
          attrs: {
            title: _vm.$t("pc_biz_imgcropper_title" /* 上传图片 */),
            visible: _vm.visible,
            "before-close": _vm.handleClose,
            size: "960px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "Cropper",
            _vm._b(
              {
                ref: "cropper",
                attrs: { src: _vm.imgUrl },
                on: {
                  complete: _vm.onComplete,
                  loading: function (v) {
                    return (_vm.loading = v)
                  },
                  "save-disable": function (v) {
                    return (_vm.disable = v)
                  },
                },
              },
              "Cropper",
              _vm.$attrs,
              false
            )
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "yxt-button",
                { attrs: { plain: "" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("pc_biz_core_btn_cancel" /* 取消 */)))]
              ),
              _c(
                "yxt-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.loading,
                    disabled: _vm.disable,
                  },
                  on: {
                    click: function () {
                      return this$1.$refs.cropper.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_core_btn_confirm" /* 确定 */)))]
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }